import React, {useState} from 'react';

const ButtonLoadFile = ({className, textButton, textButtonfileSelected ,eventUploadFile, accept, disabled}) => {
    if(!textButtonfileSelected){textButtonfileSelected="Upload File"}
    if(disabled === null || disabled === undefined){disabled=false;}

    if(!textButton){ textButton = 'Upload File...'}
    const [file, setFile] = useState({filename: null, obj: {}});
    const [input, setInput] = useState();

    const onChange = (e) => {
        setFile({
            filename: e.target.value,
            obj: e.target.files[0]
        });        
    }
    
    const uploadFile = () => {
        eventUploadFile(file.obj)
    }
    
    const handleClick = (e) => {
        input.click();
      }
    return ( 
        <>
            <input type="file" 
                hidden ref={input => setInput(input)} 
                value={file.filename}
                onChange={onChange}
                accept={accept}
            />
            <button 
                type="button"
                className={className} 
                onClick={handleClick}
                disabled={disabled}
            > {textButton}</button>
            
            {file.filename ? 
                <>
                    <hr/>
                    <button 
                        type="button"
                        className="btn btn-danger"
                        onClick={uploadFile}
                    >
                        {textButtonfileSelected}                        
                    </button>
                </>
                : null} 
        </>
     );
}
 
export default ButtonLoadFile;